// export this package's api
import BannerAnim from './BannerAnim';
import arrow from './Arrow';
import element from './Element';
import thumb from './Thumb';
import _animType from './anim';
import { setAnimCompToTagComp as toTagComp, switchChildren as swichChild } from './utils';

BannerAnim.Arrow = arrow;
BannerAnim.Element = element;
BannerAnim.Thumb = thumb;
BannerAnim.animType = _animType;
BannerAnim.setAnimCompToTagComp = toTagComp;
BannerAnim.switchChildren = swichChild;

export default BannerAnim;
export var Arrow = arrow;
export var Element = element;
export var Thumb = thumb;
export var animType = _animType;
export var setAnimCompToTagComp = toTagComp;
export var switchChildren = swichChild;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-banner-anim/es/index.js
// module id = 512
// module chunks = 0